import firebase from "firebase";

export const placeholderFile = "";

const bucket =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "waterstone-cms.appspot.com";

export const getDownloadURL = (fullPath) =>
  `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${fullPath.replace(
    /\//g,
    "%2F"
  )}?alt=media`;

export const createPlaceholderFile = async (path) => {
  await firebase
    .storage()
    .ref(path)
    .child("hidden_file_1337.txt")
    .putString(placeholderFile);
};
